import { render } from "./ManagerViewReportsApproved.vue?vue&type=template&id=96212cb0"
import script from "./ManagerViewReportsApproved.vue?vue&type=script&lang=js"
export * from "./ManagerViewReportsApproved.vue?vue&type=script&lang=js"

import "./ManagerViewReportsApproved.vue?vue&type=style&index=0&id=96212cb0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__